import { StyleSheet } from 'aphrodite';
import { hexToRgbA } from 'util/styleUtil';
// import typography from 'defaults/typography';

const getSkin = (theme) => {
    const globalProfiles = theme.globalProfiles;
	const skin = globalProfiles.palette;
	// const myTypography = typography(theme);

    return StyleSheet.create({
		completeContainer: {
			background: hexToRgbA('#303555', 0.8)
		},
		bottomContainerComponent: {
			// background: skin.white
		},
		rightContainerComponent: {
			background: 'transparent'
		},
		leftContainerComponent: {
			background: 'transparent'
		}
	});
}

export default getSkin;